export default __webpack_public_path__ + "static/media/header.413791dd.png";